import {Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SelectComponent), multi: true },
  ]
})

export class SelectComponent implements OnInit, OnChanges, ControlValueAccessor {
  propagateChange: any = () => {};
  @Input() options: SelectOption[] = [];

  @Input() parentFormGroup: FormGroup;
  @Input() formControl: FormControl;

  @Input() label: string;
  @Input() placeholder: string;
  @Input() isRequired: boolean = false;
  @Output() onModelChange: EventEmitter<any> = new EventEmitter();

  private _val: any;

  // use this to pass in a custom compare function for objects
  @Input() compareWith: (item1, item2) => boolean;

  constructor() { }

  private _initializeValues() {
    if (!this.val) {
      if (!this.placeholder && this.options.length > 0) this.val = this.options[0].value;
    }
  }
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {}
  get val() {
    return this._val;
  }

  set val(val) {
    this._val = val;
    this.propagateChange(this._val);
    this.onModelChange.emit(this._val);
  }

  modelChange($event) {
    this.onModelChange.emit(this._val);
  }


  // Called when form is initialized, with form model's initial value
  writeValue(value: any) {
    if (value) this.val = value;
    this._initializeValues();
  }

  // Access to a function that informs the outside world about changes
  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  // Callback whenever a form input is touched (ex: on blur, fires touch event)
  registerOnTouched(event) {
  }

  byValue(item1: any, item2: any): boolean {
    return item1 === item2;
  }

  trackBy(index, elem: SelectOption) {
    return elem.value;
  }

}

export class SelectOption {
  key?: string;
  text?: string;
  value: any;
  disabled?: boolean = false;
  constructor(text, value, key?) {
    this.text = text;
    this.value = value;
    this.key = key;
  }

}
